import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import SVG from 'react-inlinesvg';
import videoIcon from '@lifesize/ux-assets/vectors/svgIcons/video.svg';
import calendarIcon from '@lifesize/ux-assets/vectors/svgIcons/calendar.svg';
import returnIcon from '@lifesize/ux-assets/vectors/svgIcons/return.svg';
import CallDuration from 'components/InCall/CallDuration';
import classes from './Welcome.module.scss';

const messages = defineMessages({
  welcome: {
    id: 'components.welcome.welcome',
    description: 'Welcome label',
    defaultMessage: 'Welcome, {name}!'
  },
  welcomeBack: {
    id: 'components.welcome.welcomeBack',
    description: 'Welcome back label',
    defaultMessage: 'Welcome back, {name}!'
  }
});

const Welcome = (props) => {
  const { returnToCall, name, openCallModal, openScheduleModal, loginCount } = props;

  const message = (loginCount > 1) ? props.intl.formatMessage(messages.welcomeBack, { name }) : props.intl.formatMessage(messages.welcome, { name })

  // Determine the title message
  let titleMessage = (
    <h3 id="welcomeMessage" className={classes.welcomeMessage}>
      <span className={classes.welcomeLine} >{message}</span>
    </h3>
  );
  if (props.isCallConnected) {
    if (props.isCallMeeting) {
      titleMessage = (
        <h3 id="welcomeMessage" className={classes.welcomeMessage}>
          <FormattedMessage
            id="components.welcome.yourMeetingInProgress"
            defaultMessage="{name} is in progress"
            values={{ name: props.callContactName }}
          />
        </h3>
      );
    } else {
      titleMessage = (
        <h3 id="welcomeMessage" className={classes.welcomeMessage}>
          <FormattedMessage
            id="components.welcome.yourCallInProgress"
            defaultMessage="Your call is in progress"
          />
        </h3>
      );
    }
  }

  return (
    <div className={classes.container}>
      <header>
        {titleMessage}
        {props.isCallConnected ? (
          <h6>
            <CallDuration startTime={props.callStartTime} />
          </h6>
        ) : (
            <h6>
              <FormattedMessage
                id="components.welcome.cta"
                description="Welcome call to action"
                defaultMessage="What would you like to do?"
              />
            </h6>
          )}
      </header>
      <div className={classes.buttonBar}>
        {props.isCallConnected ? (
          <button onClick={() => returnToCall()}>
            <div className={classes.buttonIcon}><SVG src={returnIcon} /></div>
            <div className={classes.buttonLabel}>
              <FormattedMessage
                id="components.welcome.returnToCall"
                description="Welcome return to call label"
                defaultMessage="Return to Call"
              />
            </div>
          </button>
        ) : (
            <button onClick={() => openCallModal()} data-testid="homeCallButton">
              <div className={classes.buttonIcon}><SVG src={videoIcon} data-testid="videoIcon" /></div>
              <div className={classes.buttonLabel}>
                <FormattedMessage
                  id="components.welcome.call"
                  description="Welcome call label"
                  defaultMessage="Call"
                />
              </div>
            </button>
          )}
        <button onClick={() => openScheduleModal()} data-testid="homeScheduleButton">
          <div className={classes.buttonIcon}><SVG src={calendarIcon} /></div>
          <div className={classes.buttonLabel}>
            <FormattedMessage
              id="components.welcome.schedule"
              description="Welcome schedule label"
              defaultMessage="Schedule"
            />
          </div>
        </button>
      </div>
    </div>
  );
};

Welcome.propTypes = {
  intl: PT.object,
  loginCount: PT.number,
  name: PT.string,
  openCallModal: PT.func,
  openScheduleModal: PT.func,
  returnToCall: PT.func,
  callContactName: PT.string,
  callStartTime: PT.number,
  isCallConnected: PT.bool,
  isCallMeeting: PT.bool,
};

export default injectIntl(Welcome);
